module.exports = __webpack_public_path__ + "img/height_armhole.38729e1d.png";